import type { CmsApiGradFairGradProgramLinksBlockData } from '#/modules/cms/api/types/blocks/CmsApiGradFairGradProgramLinksBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';
import { dynamic } from '#/utils/dynamic';

export const CmsGradFairGradProgramLinksBlockMapping: CmsBlockMapping<CmsApiGradFairGradProgramLinksBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: dynamic(
      () =>
        import('./CmsGradFairGradProgramLinksBlock').then((m) => ({
          default: m.CmsGradFairGradProgramLinksBlock,
        })),
      { strategy: 'always' },
    ),
  };
